import { useCallback } from 'react';

import { useTrackClickedAddASubBoard } from '@air/analytics';
import { useAirModal } from '@air/provider-modal';

import { CreateBoardModal, type CreatePrivateBoardModalProps } from '~/components/Modals/CreateBoardModal';

export type UseCreateSubBoardParams = {
  enableTracking?: boolean;
};

export const useCreateSubBoard = (
  { enableTracking }: UseCreateSubBoardParams = {
    enableTracking: true,
  },
) => {
  const [showCreateBoardModal] = useAirModal(CreateBoardModal);
  const { trackClickedAddASubBoard } = useTrackClickedAddASubBoard();

  const createSubBoard = useCallback(
    (params: CreatePrivateBoardModalProps) => {
      showCreateBoardModal(params);
      if (enableTracking) {
        trackClickedAddASubBoard({ location: params.trackLocation });
      }
    },
    [showCreateBoardModal, trackClickedAddASubBoard, enableTracking],
  );

  return {
    createSubBoard,
  };
};
